<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(saveSubscription)">
        <p class="text-center font-weight-bold font-size-22 d-flex align-items-center gap-2 justify-content-center text-black">
          <span class="text-capitalize">{{ subscription }}</span>
          <span>
          <i class="fas fa-arrow-right"></i>
          </span>
          <span class="text-capitalize">
            {{ getSubscriptions(subscription) }}
          </span>
        </p>

        <b-row>
          <b-col md="12">
            <b-form-group label="End date" label-for="End date" >
              <flatPickr
                  :config="{ minDate: 'today' }"
                  :class="['form-control bg-white']"
                  v-model="subscriptionModel.date"
                  placeholder="End date"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" class="mt-4">
            <div class="d-flex justify-content-center">
              <b-button class="button-orange-modal" type="submit" v-if="!requestLoading">
                <i class="las la-pen"></i>
              </b-button>
              <b-button class="button-orange-modal" v-else>
                <spinner-loading ></spinner-loading>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </b-form>
    </ValidationObserver>
  </div>
</template>
<script>
import flatPickr from 'vue-flatpickr-component'

export default {
  name: 'profileSubscriptions',
  props: {
    requestLoading: {
      required: false,
    },
    subscription: {
      required: true,
    }
  },

  data () {
    return {
      subscriptionModel: {
        date: '',
      },
      subscriptionStep: {
        basic: 'trial',
        trial: 'pending',
        pending: 'active',
        active: 'inactive',
        inactive: 'active'
      }
    }
  },

  methods: {
    getSubscriptions (data) {
        return this.subscriptionStep[data];
    },
    saveSubscription () {
      this.$emit('submit', {
        ...this.subscriptionModel,
        status: this.getSubscriptions(this.subscription)
      });
    }
  },

  components: {
    flatPickr
  },

  created () {
  }
}
</script>

<style scoped>

</style>